<div class="card card-custom" style="height: 100%">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <div class="navi-hover scroll card-body" style="max-height: 80vh">
    <form class="form form-group-seperator-dashed" [formGroup]="manageForm">
      <div class="row">
        <div class="col-lg-6">
          <dl class="row">
            <dt class="col-sm-3 py-2">Patient:</dt>
            <dd class="col-sm-9 py-2 gl-block">
              {{
                data.patient.first_name +
                  ' ' +
                  data.patient.middle_name +
                  ' ' +
                  data.patient.last_name +
                  ' ' +
                  data.patient.last_name2
              }}
            </dd>
            <dt class="col-sm-3 py-2">Medication:</dt>
            <dd class="col-sm-9 py-2">{{ drug ? drug.drug : '' }}</dd>
          </dl>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label translate="EVENT.INPUT.DUE_DATE">Due date</mat-label>
            <input
              required
              [owlDateTime]="dt1"
              matInput
              placeholder="Due date"
              class="clendar-btn"
              formControlName="due_date"
            />
            <owl-date-time #dt1 pickerType="calendar"></owl-date-time>
            <mat-icon class="clickable" [owlDateTimeTrigger]="dt1" matSuffix>access_time</mat-icon>
            <mat-error *ngIf="isControlHasError('due_date', 'required')">
              Due Date is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" required />
            <mat-error *ngIf="isControlHasError('title', 'required')">
              Title is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Text</mat-label>
            <textarea matInput formControlName="text" rows="5" required></textarea>
            <mat-error *ngIf="isControlHasError('text', 'required')"> Text is required </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Risk</mat-label>
            <mat-select formControlName="risk" required>
              <mat-option *ngFor="let risk of risks" [value]="risk">{{ risk }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('risk', 'required')"> Risk is required </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-12">
          <kt-general-autocomplete
            #drpClassificationAutocomplete
            [appearance]="'fill'"
            [label]="'Problem Code'"
            [dataPath]="'data'"
            [loadItemsFunction]="getDRPClassificationAutocomplete"
            [optionFormatter]="formatDRPClassificationOption"
            [valueFormatter]="formatDRPClassificationOption"
            [control]="drpClassificationAutocomplete"
            [change]="handleDRPClassificationChange.bind(this)"
            [required]="true"
            [readOnly]="false"
          ></kt-general-autocomplete>
        </div>
        <div class="col-lg-12">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Classification Category</mat-label>
            <mat-select formControlName="category" required>
              <mat-option
                *ngFor="let category of classification_categories"
                [value]="category.classificationCode"
                >{{ category.classificationCode }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="isControlHasError('category', 'required')">
              Category is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12">
          <kt-general-autocomplete
            optionId="id"
            [appearance]="'fill'"
            [label]="'Causes'"
            [loadItemsFunction]="loadItems"
            [optionFormatter]="filterCauseFn"
            [valueFormatter]="filterCauseFn"
            [required]="false"
            [readOnly]="problemCodeNotExist"
            [control]="manageForm.get('causes')"
            [change]="onCauseChange.bind(this)"
            [dataPath]="'data'"
            [placeholder]="'Select Causes'"
            [formatNewObjectFn]="formatNewCauseFn"
            [chipList]="true"
            [objects]="manageForm.get('causes').value"
            #causeAutocomplete
          ></kt-general-autocomplete>
        </div>
        <div class="col-lg-12" style="padding-bottom: 10px">
          <h6 class="text-muted">Interventions</h6>
        </div>
        <div class="col-lg-12" style="padding-bottom: 10px">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            <span>{{ error }}</span>
          </kt-alert>
          <kt-alert
            *ngIf="fillDatePlz"
            type="warn"
            [showCloseButton]="true"
            [duration]="4000"
            (closeAl)="onFillClose()"
          >
            <span>Please fill the due date for the DPR in the top of the form</span>
          </kt-alert>
        </div>
        <div class="col-lg-12">
          <div class="pb-5">
            <div class="row">
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'Team'"
                  [loadItemsFunction]="filterTeamFn"
                  [optionFormatter]="stringUtils.displayTeamName"
                  [valueFormatter]="stringUtils.displayTeamName"
                  [required]="requiredTeam"
                  [readOnly]="false"
                  [control]="manageForm.get('team_responsible')"
                  [change]="selectTeam.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="''"
                  #teamAutocomplete
                ></kt-general-autocomplete>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'Template'"
                  [loadItemsFunction]="templateAutocompleteCall"
                  [optionFormatter]="filterTemplateFn"
                  [valueFormatter]="filterTemplateFn"
                  [required]="requiredTemplate"
                  [readOnly]="teamExist"
                  [control]="manageForm.get('template')"
                  [change]="onTemplateChange.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Template'"
                  #templateAutocomplete
                >
                </kt-general-autocomplete>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <div class="row">
                  <div class="col-lg-6">
                    <mat-form-field appearance="fill" class="mat-form-field-fluid">
                      <mat-label>Intervention Level</mat-label>
                      <mat-select
                        formControlName="intervention_level"
                        (selectionChange)="levelSelected()"
                        required
                      >
                        <mat-option
                          *ngFor="let level of intervention_levels | slice : 1"
                          [value]="level.id"
                          >{{ level.level }}</mat-option
                        >
                      </mat-select>
                      <mat-error> Intervention Level field is required </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <kt-general-autocomplete
                      [label]="'Intervention Code'"
                      [loadItemsFunction]="filterInterventionCodeFn"
                      [optionFormatter]="stringUtils.displayInterventionCodeName"
                      [valueFormatter]="stringUtils.displayInterventionCodeName"
                      [required]="requiredIntCode"
                      [readOnly]="levelExist"
                      [control]="manageForm.get('intervention_code')"
                      [change]="selectInterventionCode.bind(this)"
                      [dataPath]="'data'"
                      [placeholder]="''"
                      #interventionCodeAutocomplete
                    ></kt-general-autocomplete>
                  </div>
                </div>
              </div>
              <div class="col-lg-5 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Intervention Note</mat-label>
                  <input matInput formControlName="note" required />
                  <mat-error> Intervention Note field is required </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-1 kt-margin-bottom-20-mobile padding-top-4">
                <button
                  type="button"
                  (click)="addIntervention()"
                  class="btn btn-primary add-button font-weight-bold"
                  style="height: 50px; width: 100%"
                >
                  Add
                </button>
              </div>
            </div>
            <div *ngIf="interventions.length > 0">
              <div class="list" style="padding-top: 15px">
                <div
                  class="col-lg-12 kt-margin-bottom-20-mobile example-box"
                  style="margin-bottom: 10px; padding-left: 0"
                >
                  <h6 class="text-muted">Planned interventions</h6>
                </div>
                <div
                  class="col-lg-12 kt-margin-bottom-20-mobile example-box"
                  style="margin-bottom: 10px"
                >
                  <div
                    class="row"
                    style="background-color: #e1e1e1; padding: 8px; border-radius: 6px"
                  >
                    <div class="col-lg-4">
                      <p style="margin-bottom: 0">
                        <strong>Team</strong>
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <p style="margin-bottom: 0">
                        <strong>Intervention Code</strong>
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <p style="margin-bottom: 0">
                        <strong>Intervention Note</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-12 kt-margin-bottom-20-mobile example-box"
                  style="margin-bottom: 10px"
                  *ngFor="let intervention of interventions; let i = index"
                >
                  <div
                    class="row"
                    style="background-color: whitesmoke; padding: 8px; border-radius: 6px"
                  >
                    <div class="col-lg-4">
                      <p style="margin-bottom: 0">
                        {{
                          intervention.team_responsible ? intervention.team_responsible.name : null
                        }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <p style="margin-bottom: 0">
                        {{
                          intervention.intervention_code
                            ? intervention.intervention_code.code
                            : null
                        }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <p style="margin-bottom: 0">{{ intervention.note }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-lg-9"></div>
      <div class="col-lg-3" style="text-align: right">
        <button
          (click)="close()"
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
        >
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="submit"
          mat-raised-button
          color="primary"
          (click)="save()"
          matTooltip="Save changes"
        >
          <span translate="GLOBAL.SAVE">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
